
import { Card, IconButton, ModalWindow } from "@/shared/ui";
import { Skill } from "@/entities";
import { SkillProgress as SkillType } from "@/types";
import { defineComponent } from "vue";
import { AddNewSkill } from "@/features";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { storeToRefs } from "pinia";

export default defineComponent({
	name: "SkillsSection",
	components: {
		AddNewSkill,
		ModalWindow,
		IconButton,
		Skill,
		Card,
	},
	setup() {
		const store = useCharactersStore();

		const { characters, current } = storeToRefs(store);

		const { updateSkills } = store;

		return {
			characters,
			current,
			updateSkills,
		};
	},
	data() {
		return {
			addModal: false,
		};
	},
	methods: {
		add() {
			this.addModal = true;
		},
		addSkill(skill: SkillType) {
			this.updateSkills([...this.characters[this.current].skills, skill]);
		},
		update(skill: SkillType, index: number) {
			const newSkills = [...this.characters[this.current].skills];
			newSkills.splice(index, 1, skill);
			newSkills.sort((a, b) => {
				return b.level - a.level
					? b.level - a.level
					: b.experience - a.experience;
			});
			this.updateSkills(newSkills);
		},
		remove(index: number) {
			this.updateSkills(
				this.characters[this.current].skills.filter(
					(e: SkillType, i: number) => i !== index
				)
			);
		},
	},
});
